import { Box, CircularProgress, Grid } from '@mui/material'
import { useContext, useEffect, useState } from 'react'
import { AddButton } from '../components/AddButton'
import { CustomExplain } from '../components/CustomExplain'
import { CustomPaper } from '../components/CustomPaper'
import { CustomTitle } from '../components/CustomTitile'
import { Footer } from '../components/Footer'
import { ModalConfirmDialog } from '../components/ModalConfirmDialog'
import { WordList } from '../components/WordList'
import { loadStatus } from '../constants/loadStatus'
import { useAuth } from '../hooks/useAuth'
import { useC401WordGet } from '../hooks/useC401WordGet'
import { useC402WordAdd } from '../hooks/useC402WordAdd'
import { useC403WordDelete } from '../hooks/useC403WordDelete'
import type { WordInfo } from '../interfaces/WordIf'
import { LanguageContext } from '../util/LanguageContext'
import { SideMenu } from './SideMenu'

// 強調単語画面
export const Word = () => {
  const auth = useAuth()
  const c401 = useC401WordGet()
  const c402 = useC402WordAdd()
  const c403 = useC403WordDelete()
  // 文字列変換用
  const translation = useContext(LanguageContext)
  // ダイアログ
  const [openDialog, setOpenDialog] = useState(false)
  const [errorDialog, setErrorDialog] = useState('')
  // 強調単語配列
  const [words, setWords] = useState<WordInfo[]>([])

  // ローディングステータス監視
  useEffect(() => {
    if (
      c401.loading === loadStatus.LOADING ||
      c402.loading === loadStatus.LOADING ||
      c403.loading === loadStatus.LOADING
    ) {
      auth.setIsDisable(true)
    } else {
      auth.setIsDisable(false)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [c401.loading, c402.loading, c403.loading])

  // 強調単語追加ハンドラ
  const WordAddHandler = async (text: string) => {
    const result = await c402.execWordAdd(text)
    if (result.success) {
      const result = await c401.execWordGet(auth.deviceId)
      if (result.success) {
        if (result.info) {
          setWords(result.info!)
        }
      } else {
        setErrorDialog(result.message!)
        setOpenDialog(true)
      }
    } else {
      setErrorDialog(result.message!)
      setOpenDialog(true)
    }
  }
  // 強調単語削除ハンドラ
  const WordDelHandler = async (text: string) => {
    const result = await c403.execWordDelete(text)
    if (result.success) {
      const result = await c401.execWordGet(auth.deviceId)
      if (result.success) {
        if (result.info) {
          setWords(result.info!)
        } else {
          setWords([])
        }
      } else {
        setErrorDialog(result.message!)
        setOpenDialog(true)
      }
    } else {
      setErrorDialog(result.message!)
      setOpenDialog(true)
    }
  }

  // 起動時
  useEffect(() => {
    const fetchData = async () => {
      const result = await c401.execWordGet(auth.deviceId)
      if (result.success) {
        if (result.info) {
          setWords(result.info!)
        }
      } else {
        setErrorDialog(result.message!)
        setOpenDialog(true)
      }
    }

    fetchData()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  // ダイアログクローズ
  const handleDialogClose = () => {
    setErrorDialog('')
    setOpenDialog(false)
  }
  return (
    <>
      {openDialog && (
        <ModalConfirmDialog
          open={openDialog}
          text={errorDialog}
          onClick={() => handleDialogClose()}
        />
      )}
      <Box sx={{ display: 'flex', p: 0 }}>
        <Box sx={{ p: 0, width: '338px', flexShrink: 0 }}>
          <SideMenu />
        </Box>
        <Box sx={{ flexGrow: 1, overflowX: 'auto' }} display="flex" flexDirection="column">
          <Box marginTop={13}>
            <CustomTitle>{translation['label_emphasis_words']}</CustomTitle>
          </Box>
          <Box
            sx={{
              position: 'fixed',
              top: '50%',
              left: '50%',
              transform: 'translate(-50%, -50%)',
              zIndex: 9999,
            }}
          >
            {(c401.loading === loadStatus.LOADING ||
              c402.loading === loadStatus.LOADING ||
              c403.loading === loadStatus.LOADING) && <CircularProgress />}
          </Box>
          <Box>
            <CustomExplain>{translation['message_emphasis_word_info']}</CustomExplain>
          </Box>
          <Box
            sx={{
              marginTop: '40px',
            }}
          >
            <CustomPaper>
              <Grid container spacing={2}>
                <Grid item lg={6} xl={3.7}>
                  <AddButton title={translation['label_emphasis_words']} onAdd={WordAddHandler}>
                    {translation['button_add_new']}
                  </AddButton>
                </Grid>
                <WordList items={words} onDeleteWord={WordDelHandler} />
              </Grid>
            </CustomPaper>
          </Box>
        </Box>
      </Box>
      <Footer />
    </>
  )
}
